// 引入Three.js
import * as THREE from 'three';
// 引入gltf模型加载库GLTFLoader.js
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
//1.给原来的gltf加载器设置解压功能
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

//2.压缩 gltfpack -i inputFile.glb -o outputFile.glb -cc
// import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'


// import gui from './gui.js'

//创建材质子菜单
// const matFolder = gui.addFolder('牙齿材质');
// matFolder.close(); //关闭菜单

const loader = new GLTFLoader(); //创建一个GLTF加载器

//1.解压算法1
const draco = new DRACOLoader();//创建解码器实例
draco.setDecoderPath('../static/draco/');//设置解压库文件路径
loader.setDRACOLoader(draco);//加载解码器实例   

//2.解压算法2
// loader.setMeshoptDecoder(MeshoptDecoder)

//loader.setMeshoptDecoder(MeshoptDecoder);
const setpMeshGroup = new THREE.Group(); //添加指定步数的网格模型对象，参数（几何体，材质）
const upMeshGroup = new THREE.Group(); //所有步数的上牙齿网格对象
const downMeshGroup = new THREE.Group(); //所有步数的下牙齿网格对象

var upMesh = new THREE.Mesh(); //上牙齿网格对象，参数（几何体，材质）
var downMesh = new THREE.Mesh(); //所有下牙齿对象

//纹理贴图加载器TextureLoader
const texLoader = new THREE.TextureLoader();
// .load()方法加载图像，返回一个纹理对象Texture
const texture = texLoader.load('../static/image/yy.png');

//准备加载模型
let prefixPath = null; //模型前缀地址


//初始化加载第一步模型
const initLoadModel = (sn,upMaxStep,downMaxStep)=>{
    prefixPath = '../static/model/' + sn + '/glb/';  
    //加载初始步数的数据
    loadAllModelData(upMaxStep,downMaxStep);
}

// 点击步数请求
const stepClick = (currentStep)=>{ 
    cloneDataByStep(currentStep);   
}

const gumArr = ['up/', 'down/'];
function loadAllModelData(upMaxStep,downMaxStep) {
    gumArr.forEach(function (val) {
        let maxStep = upMaxStep;
        if (val == "down/"){
            maxStep = downMaxStep;
        }

        for(let step = 1; step　< maxStep; step++) {
            let formatSetp = step;
            let eachGumAllPath = prefixPath + val + formatSetp + ".glb"; 
            // console.log("================================加载模型的路径:",eachGumAllPath)
            loader.load(eachGumAllPath, function (gltf) { //gltf加载成功后返回一个对象
                //递归遍历gltf包含所有的模型节点
                gltf.scene.traverse(function (obj) {
                    // console.log('模型节点', obj);
                    if (obj.isMesh) {
                        if (obj.name.indexOf("Jaw") !== -1) { 
                            var material = new THREE.MeshPhongMaterial({
                                map: texture
                            });
                        } else {
                            //把原来的 网格基础材质MeshBasicMaterial 转为 网格高光材质MeshPhongMaterial
                            var material = new THREE.MeshPhongMaterial({
                                color: 0xf2efe5,
                                shininess: 130, //高亮的程度，越高的值越闪亮
                                specular: 0xdfd6bf, //材质的高光颜色
                                side: THREE.DoubleSide,
                                flatShading: false,
                                transparent: true,//开启透明
                                opacity: 1, //设置透明度 0.0 - 1.0的范围内的浮点数，表明材质的透明度。值0.0表示完全透明，1.0表示完全不透明
                                Text:1
                            });
                            //判断是否是附件模型，设置其颜色
                            // if (val.indexOf("Atta") !== -1) {
                            //     material.color.set("#e57f79");
                            // }
                        }
                        obj.material = material;

                    } else {
                        console.info("对象obj不是网格模型Mesh")
                    }
                });

                //模型放正
                gltf.scene.rotateY(0.8);
                gltf.scene.rotateX(1.4);
                gltf.scene.position.set(0, 0, 0); //模型相对于三维空间中位置坐标
                gltf.scene.name = step;
                if (val == "up/") {
                    //三维场景添加到model组对象中
                    upMeshGroup.add(gltf.scene);
                } else if (val == "down/") {
                    downMeshGroup.add(gltf.scene);
                }                
               let loadStep = upMeshGroup.children.length + downMeshGroup.children.length;
               document.getElementById("loadingValue").innerText = Math.floor((100 / (upMaxStep + downMaxStep)) * loadStep) + '%';
                //4类模型全部加载完毕，隐藏加载图
                if(downMeshGroup.children.length === downMaxStep-1 && upMeshGroup.children.length === upMaxStep-1){
                    document.getElementById("loadDiv").style.display = 'none';                
                    cloneDataByStep(1);
                }             
            });
        }
    });       
}


//获取网格对象组中的一个对象
function cloneDataByStep(currentStep){
    let getUpMeshGroup = upMeshGroup.getObjectByName(currentStep);    
    if(getUpMeshGroup !== undefined){
        //清空对象，重新加载其中一步的网格对象
        upMesh.clear();
        // console.log("============step:",currentStep);
        // console.log("###############上牙模型条数：",upMeshGroup);
        // console.log("###############上牙模型条数：",upMeshGroup.getObjectByName(currentStep));
        // console.log("------------------------1.上牙模型条数：",upMeshGroup.children.length);
        // console.log("------------------------2.下牙模型条数：",downMeshGroup.children.length);
        // console.log("------------------------3.上牙附件模型条数：",upAttaMeshGroup.children.length);
        // console.log("------------------------4.下牙附件模型条数：",downAttaMeshGroup.children.length);
        upMesh.add(getUpMeshGroup.clone());
    }

    let getDownMesGroup = downMeshGroup.getObjectByName(currentStep);
    if(getDownMesGroup !== undefined){
        //清空对象，重新加载其中一步的网格对象
        downMesh.clear();
        downMesh.add(getDownMesGroup.clone());
    }
}

setpMeshGroup.add(upMesh, downMesh);
export default setpMeshGroup;
export {initLoadModel,stepClick};



// WEBPACK FOOTER //
// ./src/business/modelGltf.js